import { createAdminBondRequestPreviews } from "./AdminBondRequestPreviews";

export const AdminBondRequestPreviewsOpen = createAdminBondRequestPreviews(
	"admin_bond_requests_open_v2",
	({ status }) =>
		status === "accepted" || status === "approved" || status === "pending" || status === "review",
);
